module.exports = __webpack_public_path__ + "img/gov.92961d9c.png";